const reg = new RegExp("iPhone|iPod|incognito|webmate|Android.*Mobile|dream|CUPCAKE|froyo|BlackBerry|webOS|s8000|bada|IEMobile|Googlebot\-Mobile|AdsBot\-Google");
const configure = {
  NAME: '',
  MSG: {
    USE_CHROME: 'お使いのブラウザはサポート対象外です。Chromeブラウザで開きますか？',
    NOT_SUPPORT: 'お使いのブラウザはサポート対象外です。最新バージョンのブラウザで御覧ください。'
  },
  IS_SSL: location.protocol.indexOf('https') !== -1,
  IS_APP: () =>{
    const classList = document.getElementsByTagName('body')[0].classList;
    if(typeof classList === 'undefined'){
      return false;
    }else{
      return classList.contains("utme-app-wv");
    }
  },
  IS_PC: !reg.test(window.navigator.userAgent),
  FPS: 30,
  SUPPORT: {
    IE_MIN: 11.0,
    IOS_MIN: 9.0,
    ANDROID_MIN: 4.2,
  },
  MAX_UPLOAD_SIZE: 5000000, //5MB
  ENV: function (){
    if(location.hostname.indexOf('uniqlo.com') === -1){
      return 'DEV';
    }else if(location.hostname == '153.120.6.220'){
      return 'PREVIEW';
    }else if(location.hostname == '175.41.241.98' || location.hostname == 'prodtest.uniqlo.com'){
      return 'STAGING';
    }else{
      return 'PRODUCTION';
    }
  },
  TOPPAGE: function (){
    switch(this.ENV()){
      case 'DEV':
        return location.origin+'/';
      case 'PREVIEW':
        return location.origin+'/';
      case 'STAGING':
        return location.origin+'/';
      case 'PRODUCTION':
        return location.origin+'/';
    }
  },
  API_URL: function (){
    const IS_APP= (typeof document.getElementsByTagName('body')[0].classList === 'undefined')?false:document.getElementsByTagName('body')[0].classList.contains("utme-app-wv");
    if(IS_APP){
      //APP
      return '/jp/front/peanuts/create?locale=ja';
    }else if(this.IS_PC){
      //PC
      return '/jp/front/mkt/peanuts/create?locale=ja';
    }else{
      //SP
      return '/jp/front/market/peanuts/create?locale=ja';
    }
  },
  PROTOCOL: function (){
    switch(this.ENV()){
      case 'DEV':
        return 'http';
      case 'PREVIEW':
        return 'https';
      case 'STAGING':
        return 'https';
      case 'PRODUCTION':
        return 'https';
    }
  }
};
export default configure;



// WEBPACK FOOTER //
// ./source/javascripts/configure.js